import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import Flex from 'components/Flex'
export const MainFlex = styled(Flex)`
  padding: 5px 12px 5px 20px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 8px;
  width: 100%;
  min-height: 82px;
  cursor: pointer;
  margin-bottom: 20px;
  opacity: ${props => (props?.disable ? '0.5' : '1')};
  pointer-events: ${props => (props?.disable ? 'none' : 'auto')};
`
export const TitleFlex = styled(Flex)`
  gap: 8px;
  flex: 0.6;
`
export const TiltleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  color: ${COLORS.GREY_T_30};
`
export const ContentDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: #989898;
  flex: 0.5;
`
